import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerioExamDirectionItem } from '../perio-exam-direction-card/perio-exam-direction-card.component';

@Component({
  selector: 'lib-perio-exam-carousel-orb',
  imports: [CommonModule],
  templateUrl: './perio-exam-carousel-orb.component.html',
  styleUrl: './perio-exam-carousel-orb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PerioExamCarouselOrbComponent {
  public readonly examDirection = input.required<PerioExamDirectionItem>();
}
